import { render, staticRenderFns } from "./planList.vue?vue&type=template&id=2f024298&scoped=true&"
import script from "./planList.vue?vue&type=script&lang=js&"
export * from "./planList.vue?vue&type=script&lang=js&"
import style0 from "./planList.vue?vue&type=style&index=0&id=2f024298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f024298",
  null
  
)

export default component.exports